import React from "react";
import ErrorHandler from "../../../components/shared/with-error-handler";
import FranchiseContainer from "../../../components/desktop/franchise";
import withLayout from "../../../components/desktop/layout/component";
import withReducer from "../../../components/shared/with-reducer";
import injectableReducers from "./injectable";

const Franchise = () => {
    return (
        <React.Fragment>
            <ErrorHandler>
                <FranchiseContainer />
            </ErrorHandler>
        </React.Fragment>
    );
};

export default withReducer(injectableReducers)(() => ({}), (dispatch) => ({ dispatch })
)(withLayout(Franchise));
